// v1.0.0 - 2026-01-28 - Reports page placeholder

import { PageContainer, PageHeader } from '@/components/layout/PageContainer'
import { Card, CardContent } from '@/components/ui/card'

export default function ReportsPage() {
  return (
    <PageContainer>
      <PageHeader
        title="Report"
        description="Esportazione report e documenti"
      />
      <Card>
        <CardContent className="py-12 text-center text-[var(--color-text-secondary)]">
          Report in arrivo (Sprint 5)
        </CardContent>
      </Card>
    </PageContainer>
  )
}
